import {Autocomplete, Box, TextField} from "@mui/material";
import React, {useState} from "react";
import {MultiSearchProps} from "../../components/SearchBox";
import {Tables} from "../../apitypes";
import AvatarImage from "../storage/AvatarImage";
import {useGetProductQuery} from "./product_api";

export default ({onChange, value, label}: MultiSearchProps<Tables<"product">>) => {

    const [filter, setFilter] = useState("");
    const {data} = useGetProductQuery({
        filter: filter,
        pageSize: 30,
        page:0,
        sort: [{col: "Code", dir: "desc"}]
    })

    return <Autocomplete
        id={"INVc"}
        multiple
        options={data?.result ||[]}
        autoHighlight
        sx={{minWidth: "200px"}}
        value={value}
        filterOptions={x => x}

        onChange={(e, v: Tables<"product">[]) => onChange(v)}
        getOptionLabel={(option: Tables<"product">) => {
            return option.Name;
        }}
        getOptionKey={v => v.Code}
        onInputChange={(e,v) => setFilter(v)}
        renderOption={(props, option: Tables<"product">) => {
            const {key, ...rest} = props
            return <Box component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} key={key} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"products"}/>   {option.Name} ({option.Code})
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
               
                label={label || "Artikel"}
                variant={"standard"}
            />
        )}
    />

}
